const viewAds = import.meta.env.VITE_VIEW_ADS;

const CommercialBanner = () => {
  if (viewAds === "false" || !viewAds) return null;

  return (
    <div className="bg-base-300 text-white w-full pt-10 pb-2 px-6 rounded-2xl max-w-7xl m-auto shadow-lg my-8 relative">
      <h2 className="text-5xl font-bold mb-8 text-center">
        Vill <span className="italic">ditt</span> företag eller{" "}
        <span className="italic">ditt</span> band synas här?
      </h2>
      <div className="my-6 text-center">
        <a href="/contact">
          <button className="btn btn-primary font-semibold btn-wide py-2 px-6 mx-4 my-2">
            Kontakt
          </button>
        </a>
        <a href="/partnership">
          <button className="btn btn-secondary btn-outline btn-wide font-semibold py-2 px-6 mx-4">
            Om att syns här
          </button>
        </a>
        <p className="text-md font-semibold text-center italic pt-4">
          Stöd{" "}
          <a href="/about" className="font-bold underline">
            Lokult
          </a>{" "}
          och den lokala musiken
        </p>
        <p className="text-red-600 text-4xl">♥️</p>
      </div>
    </div>
  );
};

export default CommercialBanner;
